import React from 'react';
import moment from 'moment';
import { CheckSquare, AlertTriangle, TriangleAlert } from 'lucide-react';

export const TaskEvent = ({ event, OnRedirect ={} }) => {
  const formatDateRange = () => {
    if (!event.startDate && !event.endDate) return null;
    
    // Only start date
    if (event.startDate && !event.endDate) {
      return `From ${moment(event.startDate).format('MMM D')}`;
    }
    
    // Only end date
    if (!event.startDate && event.endDate) {
      return `Until ${moment(event.endDate).format('MMM D')}`;
    }
    
    // Both dates
    const start = moment(event.startDate);
    const end = moment(event.endDate);
    
    if (start.isSame(end, 'day')) {
      return start.format('MMM D');
    }
    
    return `${start.format('MMM D')} - ${end.format('MMM D')}`;
  };

  const getPriorityColor = () => {
    if (event.isCritical) return 'critical';
    if (event.priority && event.priority === 2) return 'high';
    if (event.priority && event.priority === 1) return 'moderate';
    return 'low';
  };
  
  const handleRedirection = () => {
    if (OnRedirect) {
      OnRedirect();
    }
  };

  return (
    <div 
      onClick={() =>{handleRedirection()}}
      className={`task-event task-event--${getPriorityColor()}`}>
      <div className="task-event__header">
        <div className="task-event__icon">
          <CheckSquare />
        </div>
        <div className="task-event__title-section">
          <h6 className="task-event__title">{event.name}</h6>
          {event.project && (
            <span className="task-event__project">{event.project?.name}</span>
          )}
        </div>
        <div className="task-event__badges">
          {event.isCritical && (
            <span className="task-event__badge task-event__badge--critical">
              <AlertTriangle size={12} />
              Critical
            </span>
          )}
          {event.isMilestone && (
            <span className="task-event__badge task-event__badge--milestone">
              Milestone
            </span>
          )}
        </div>
      </div>

      <div className="task-event__details">
        {Number(event.risks) > 0 && (
          <span className="inline-flex items-center justify-start gap-1">
            <TriangleAlert size={12} color='#dc2626'/> <strong>Risks:</strong> {event.risks}
          </span>
        )}
        {event.scope && (
          <div className="task-event__scope">
            <strong>Scope:</strong> {event.scope?.name}
          </div>
        )}
        
        {formatDateRange() && (
          <div className="task-event__dates">
            <strong>Duration:</strong> {formatDateRange()}
          </div>
        )}
        
        {event.progress !== undefined && (
          <div className="task-event__progress">
            <strong>Progress:</strong>
            <div className="task-event__progress-bar">
              <div 
                className="task-event__progress-fill"
                style={{ width: `${event.progress}%` }}
              />
            </div>
            <span className="task-event__progress-text">{event.progress}%</span>
          </div>
        )}
      </div>
    </div>
  );
};